import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Button, Spinner } from 'react-bootstrap';
import UserForm from '../forms/UserForm';
import '../styles/EmployeeMaster.css';
import UserTable from '../components/UserTable';

const UserEditModel = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams(); // ✅ Get ID from route

  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Show modal only if URL starts with /users/edit
  const showModal = location.pathname.startsWith('/users/edit');

  const handleCloseModal = () => {
    navigate('/users'); // Go back to list
  };

  // ✅ Fetch USER details by ID
  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      fetch(`${baseUrl}/getRadiologyUserById/${id}`)
        .then(res => res.json())
        .then(data => {
          if (data.status) {
            setUserData(data.data);
          } else {
            setUserData(null);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching user by ID:', err);
          setLoading(false);
        });
    }
  }, [id, showModal]);

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>User Master</h2>
      </div>

      {/* Table of USERs */}
      <UserTable />

      {/* Edit Modal */}
      <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" /> Loading...
            </div>
          ) : userData ? (
            <UserForm userId={id} initialData={userData} /> // ✅ Pass data to form
          ) : (
            <p className="text-center">No data found for this USER.</p>
          )}
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary">
            Save
          </Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
};

export default UserEditModel;
